export const EDIT_TITLE = 'EDIT_TITLE';

export const TYPE = {
	CATEGORY: 'category',
	MENU_LEVEL: 'menuLevel',
	SUPPLEMENT_CATEGORY: 'supplementCategory',
};
